import React from 'react';
import styled from 'styled-components';
import homeImage from '../assets/homeImage.png';

export default function Appointment() {
 return (
  <Container>
   <Wrapper>
    <div>
     <div className='header'>
      <Heading>EPR Registration Compliance</Heading>
     </div>

     <Form>
      <div>
       <label htmlFor='name'>Name</label>
       <input type='text' name='name' id='name' />
      </div>
      <div>
       <label htmlFor='email'>Email Address</label>
       <input type='email' name='email' id='email' />
      </div>
      <div>
       <label htmlFor='phoneNumber'>Phone Number</label>
       <input
        type='tel'
        name='phoneNumber'
        id='phoneNumber'
        pattern='[0-9]{3}-[0-9]{3}-[0-9]{4}'
       />
      </div>
      <div>
       <label htmlFor='company'>Company</label>
       <input type='text' name='company' id='company' />
      </div>
      <div>
       <label htmlFor='desc'>Description</label>
       <textarea type='text' name='desc' id='desc' />
      </div>
     </Form>

     <div className='button'>SUBMIT</div>
    </div>
    <div>
     <Image src={homeImage} alt='hand holding a small plant' />
    </div>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background: #000;
`;

const Wrapper = styled.div`
 background: #000;
 display: flex;
 align-items: center;
 flex-direction: row-reverse;
 width: 75%;
 margin: 0 auto;
 justify-content: space-between;
 > div {
  width: 50%;
  height: 100%;
 }
 > div:first-child {
  width: 50%;
  height: 100%;
  padding: 8rem 0;
  position: relative;
 }
 .header {
  width: 100%;
  text-align: left;
  p {
   color: #fff;
   font-weight: 400;
   font-size: 1.5rem;
   margin-bottom: 2rem;
  }
 }
 .button {
  background: #90d62b;
  border-radius: 1rem;
  color: #e8e8e8;
  font-size: 1.5rem;
  width: fit-content;
  padding: 0.5rem 2rem;
  left: 0;
  margin-right: auto;
  font-weight: 600;
  cursor: pointer;
 }
`;

const Heading = styled.h1`
 font-size: 3rem;
 font-weight: 500;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #fff;
`;

const Image = styled.img`
 width: 70%;
 height: auto;
 object-fit: cover;
`;

const Form = styled.form`
 form {
  width: 100%;
 }
 label {
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: 0.3px;
  color: #ababab;
  display: block;
  margin-bottom: 0.5rem;
 }
 div {
  margin-bottom: 2.5rem;
  text-align: left;
 }
 input,
 textarea {
  outline: none;
  border: none;
  padding: 0.75rem 1rem;
  font-size: 1.5rem;
  width: 100%;
  background: #000000;
  border: 0.909286px solid #ababab;
  border-radius: 0.75rem;
  color: #fff;
 }
`;
